import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'
import * as R from 'ramda'
import P from 'helpers/predicates'

import {
  POST_LOGOUT_USER_SUCCESS,
} from 'containers/User/Login/constants'

import {
  GLOBAL_ROLES,
  ROUTE_ROLES
} from 'containers/Role/constants'

import {
  UPDATE_GLOBAL_ROLE,
  UPDATE_PROJECT_ROLE,
  UPDATE_DATA_MANAGER_ROLE,
  UPDATE_CLIENT_ROLE,
  CHANGE_GLOBAL_ROLE_SUCCESS,
} from './constants'

// filter out global roles and than add
const isGlobalRole = R.flip(R.contains)(R.values(GLOBAL_ROLES))
const isNotGlobalRole = R.complement(isGlobalRole)
const removeGlobalRoles = R.filter(isNotGlobalRole)

const removeAndAddGlobalRole = (newRole, prevRoles) => R.compose(
  R.append(newRole),
  removeGlobalRoles
)(prevRoles)

const removeAndAddRouteRole = (newRole, prevRoles) => R.compose(
  R.uniq,
  R.append(newRole)
)(prevRoles)

const updateGlobalRole = (prevRoles, { role }) => P.isNotNil(role)
  ? removeAndAddGlobalRole(role, prevRoles)
  : prevRoles

const updateProjectRole = (prevRoles, { hasRole }) => hasRole
  ? removeAndAddRouteRole(ROUTE_ROLES.PROJECT_CREATE, prevRoles)
  : prevRoles

const updateDataManagerRole = (prevRoles, { hasRole }) => hasRole
  ? removeAndAddRouteRole(ROUTE_ROLES.DATA_MANAGER, prevRoles)
  : prevRoles

const updateClientRole = (prevRoles, { isClient }) => isClient
  ? removeAndAddGlobalRole(GLOBAL_ROLES.CLIENT_ACCESS, prevRoles)
  : prevRoles

const globalRoleReducer = createReducer([GLOBAL_ROLES.LIMITED_ACCESS], {
  [UPDATE_GLOBAL_ROLE]: updateGlobalRole,
  [UPDATE_PROJECT_ROLE]: updateProjectRole,
  [UPDATE_DATA_MANAGER_ROLE]: updateDataManagerRole,
  [UPDATE_CLIENT_ROLE]: updateClientRole,
})

const globalRoleLoadedReducer = createReducer(false, {
  [CHANGE_GLOBAL_ROLE_SUCCESS]: () => true,
  [POST_LOGOUT_USER_SUCCESS]: () => false
})

export default combineReducers({
  roles: globalRoleReducer,
  isLoaded: globalRoleLoadedReducer
})
